import { render, staticRenderFns } from "./Subclientes.vue?vue&type=template&id=4be3af54"
import script from "./Subclientes.vue?vue&type=script&lang=js"
export * from "./Subclientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports